export const GUEST_ID_KEY = 'PGG2_GUEST_ID';

export const GUEST_ID_COOKIE_NAME = ['PGG2_guest_id'];
